import { safeRegexExec } from './safeRegex';
import { Message } from '@/types/chat/chat';

export interface DocumentLink {
  id: string;
  name: string;
  path: string;
}

export async function parseMessage(
  message: Message,
  documentLinks: DocumentLink[],
): Promise<string> {
  const lines = message?.response?.split('\n') ?? [];

  const processedLines = await Promise.all(
    lines.map(async (line: string) => {
      try {
        const results = await safeRegexExec(
          line,
          '([^\\s();]+)\\s*\\(\\s*([^,()]+)\\s*,\\s*(document_[\\w]+|file_[\\w]+)\\s*,\\s*(\\d+)\\)',
          'g',
          3000,
        );

        let replacedLine = line;
        const linkIndex: { [file_id: string]: number } = {};

        if (Array.isArray(results)) {
          for (const match of results) {
            const [full, quotedText, fileName, fileId, page] = match;
            const file = documentLinks.find(item => item.id === fileId);

            if (file?.name && file?.path) {
              linkIndex[fileId] = (linkIndex[fileId] || 0) + 1;
              const index = linkIndex[fileId] - 1;
              const url = `${file.path}&id=${fileId}&index=${index}&msg_id=${message.id}`;

              const replaced = `${quotedText.trim()} (Pg ${page}, [${file.name}](${url}&id=${fileId}&page=${page}&msg_id=${message.id}&ref=${encodeURIComponent(
                quotedText.trim(),
              )}))`;

              replacedLine = replacedLine.replace(full, replaced);
            }
          }
        }

        return replacedLine;
      } catch (err) {
        return line;
      }
    }),
  );

  return processedLines.join('\n');
}
